import Contact from './contact';
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

// wrap the app component with the GoogleReCaptchaProvider
export default () => (
    <GoogleReCaptchaProvider reCaptchaKey="6LeU2n4pAAAAACRrmBrl6o6WbHSw-jRCtVZBiCd2" size="compact" badge="bottomright">
      <Contact />
    </GoogleReCaptchaProvider>
  );